module.exports = __webpack_public_path__ + "img/Step16.a3d6fe0b.png";